import '../fake-db';
import { Provider } from 'react-redux';
import { useRoutes } from 'react-router-dom';
import { MatxTheme } from './components';
import { AuthProvider } from './contexts/JWTAuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { SystemProvider } from './contexts/SystemContext';
import { Store } from './redux/Store';
import routes from './routes';
import './views/systems/style.css';
import { SnackbarProvider } from 'notistack';

const App = () => {
  const content = useRoutes(routes);

  return (
    <Provider store={Store}>
      <SettingsProvider>
        <MatxTheme>
          <AuthProvider>
            <SnackbarProvider maxSnack={10}>
              <SystemProvider>{content}</SystemProvider>
            </SnackbarProvider>
          </AuthProvider>
        </MatxTheme>
      </SettingsProvider>
    </Provider>
  );
};

export default App;
